<script lang="ts">
	import type { Address } from "proto/address";

	import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";
	import { voteForArea, type VotingArea } from "$lib/serv/user";
	import { toYYYYMMDD } from "$lib/util/format";

	import Illustration from "$lib/ui/layout/Illustration.svelte";
	import Input from "$lib/ui/form/Input.svelte";

	export let location: Partial<Address>;

	let email: string;
	let thankYou: boolean = false;
	let savingAddress: any;

	function save(addr: typeof location) {
		savingAddress = true;
		
		const body: VotingArea = {
			type: "area-not-serviced",
			location: `${addr.latitude}, ${addr.longitude}`,
			latitude: addr.latitude ?? '',
			longitude: addr.longitude ?? '',
			street_name: addr.street_name ?? '',
			city: addr.town ?? '',
			province: addr.province ?? '',
			postal_code: addr.postal_code ?? '',
			date: toYYYYMMDD(new Date()),
			source: "WEB_APP",
			email: email,
		};
		voteForArea(body).subscribe((res: any) => {
			thankYou = res.success && res.success.http_response_code === 200 ? true : false;
			savingAddress = false;
		})
	}
</script>

<div class="max-w-800 m-auto">
	{#if !thankYou}
		<div class="img text-center">
			<Illustration src='area-not-covered-light' />
		</div>
		<div class="text-center">
			<h2  class="display-m bold">We're not covering this area just yet..</h2>
			<p class="body-m medium">But we're working on it! We can email you when we expand.</p>
		</div>

			<Input
				id="address"
				label="Enter email"
				placeholder="eg: bob@example.com"
				bind:value={email}
				required
			/>
			<button class="button" on:click={() => save(location)} disabled={savingAddress}>Vote for my area</button>
			<div>
		</div>
	{:else}
		<div class="text-center">
			<div class="img">
				<Illustration src='thanks-for-voting' />
			</div>
			<h2  class="display-m bold">Thank you!</h2>
			<p class="body-m medium">You'll be the first to know when we arrive in your area.</p>
			<div>
				<button class="button" on:click={() => selectAddress()}>Try another address</button>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@use 'screen';

	.img {
		@media (screen.$max-sm) { display: none; }
	}

	.button { width: 100%; }

</style>